import { render, staticRenderFns } from "./References.vue?vue&type=template&id=58fa0852&scoped=true&"
import script from "./References.vue?vue&type=script&defer=true&lang=js&"
export * from "./References.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./References.vue?vue&type=style&index=0&id=58fa0852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa0852",
  null
  
)

export default component.exports